var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditPensil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.99963 23.2799V27.3333C3.99963 27.7066 4.29297 27.9999 4.6663 27.9999H8.71963C8.89297 27.9999 9.0663 27.9333 9.1863 27.7999L23.7463 13.2532L18.7463 8.25325L4.19963 22.7999C4.0663 22.9332 3.99963 23.0932 3.99963 23.2799ZM27.613 9.38658C28.133 8.86658 28.133 8.02658 27.613 7.50658L24.493 4.38658C23.973 3.86658 23.133 3.86658 22.613 4.38658L20.173 6.82658L25.173 11.8266L27.613 9.38658Z",
    fill: "#367C68"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPensil);
export default __webpack_public_path__ + "static/media/edit_pensil.2d6850cc01da79c262f5dd8d61f21f31.svg";
export { ForwardRef as ReactComponent };